import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Container, Row, Col, Button, FormGroup, FormText, Input } from "reactstrap";
import { loginUser } from "../../actions/auth";
import hasToken from "../../services/authService";
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import loginImage from "../../assets/see.png";
import Logotime from "../../components/Icons/time.png";
import Widget from "../../components/Widget/Widget";
import GoogleIcon from "../../components/Icons/AuthIcons/GoogleIcon.js";
import TwitterIcon from "../../components/Icons/AuthIcons/TwitterIcon.js";
import FacebookIcon from "../../components/Icons/AuthIcons/FacebookIcon.js";
import GithubIcon from "../../components/Icons/AuthIcons/GithubIcon.js";
import LinkedinIcon from "../../components/Icons/AuthIcons/LinkedinIcon.js";
import BaseAPI from "../../api/apiurl";
import 'react-notifications/lib/notifications.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/tost.css';

const Login = (props) => {
  const [username, setUsername] = useState('');
  const [pass, setPass] = useState('');
  const [customername, setCustomername] = useState('');
  const history = useHistory();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [customerId, setCustomerId] = useState('');
  const [companyId, setCompanyId] = useState('');


  const handleLogin = async (e) => {
    e.preventDefault();
    let loginSuccess = false;
    let userLoginSuccess = false;
    let loginError = null;
    let userLoginError = null;
  
    try {
      const loginResponse = await axios.post(`${BaseAPI}login`, {
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
          'Access-Control-Allow-Methods': 'OPTIONS,POST',
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          'X-Requested-With': '*',
        },
        username,
        pass,
        customername,
      });
  
      if (loginResponse.data && loginResponse.data.data && loginResponse.data.data.service) {
        const { companyid, customerid, username, userid, modules, role , vendorname , customer , customername ,
          password} = loginResponse.data.data.service;
  
        // Store companyid and customerid in local storage
        localStorage.setItem('companyid', companyid);
        localStorage.setItem('customerid', customerid);
        localStorage.setItem('username', username);
        localStorage.setItem('userid', userid);
        localStorage.setItem('modules', modules);
        localStorage.setItem('role', role);
        localStorage.setItem('domain', loginResponse.data.data.domain);
        localStorage.setItem('customername', customername);
        localStorage.setItem('password', password);
        // localStorage.setItem('vendorname', vendorname);
        // localStorage.setItem('customer', customer);
  
        const storedCustomerId = localStorage.getItem('customerid');
        const storedCompanyId = localStorage.getItem('companyid');
  
        if (storedCustomerId) {
          setCustomerId(storedCustomerId);
        }
  
        if (storedCompanyId) {
          setCompanyId(storedCompanyId);
        }
  
        localStorage.setItem('auth', true);
        loginSuccess = true;
      } else {
        loginError = 'Invalid response data';
      }
    } catch (error) {
      loginError = 'An error occurred during login';
      console.error(error);
    }
  
    try {
      const userLoginResponse = await axios.post(`${BaseAPI}userlogin`, {
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
          'Access-Control-Allow-Methods': 'OPTIONS,POST',
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          'X-Requested-With': '*',
        },
        username,
        pass,
        customername,
      }); 
  
      if (userLoginResponse.data && userLoginResponse.data.data && userLoginResponse.data.data.user) {
        const { id,companyid, customerid, username, userid, modules, roleid , customername , vendorname , customer } = userLoginResponse.data.data.user;
  
        // Store companyid and customerid in local storage
        localStorage.setItem('id', id);
        localStorage.setItem('companyid', companyid);
        localStorage.setItem('customerid', customerid);
        localStorage.setItem('username', username);
        localStorage.setItem('userid', userid);
        localStorage.setItem('modules', modules);
        localStorage.setItem('role', roleid);
        localStorage.setItem('customername', customername);
        // localStorage.setItem('vendorname', vendorname);
        // localStorage.setItem('customer', customer);
        const storedCustomerId = localStorage.getItem('customerid');
        const storedCompanyId = localStorage.getItem('companyid');
        localStorage.setItem('auth', true);
  
        if (storedCustomerId) { 
          setCustomerId(storedCustomerId);
        }
  
        if (storedCompanyId) {
          setCompanyId(storedCompanyId);
        }
  
        userLoginSuccess = true;
      } else {
        userLoginError = 'Invalid login response data';
      }
    } catch (error) {
      userLoginError = 'An error occurred during user login';
      console.error(error);
    }
  
    if (loginSuccess) {
      toast.success('Login successful!', {
        autoClose: 1500,
        position: 'top-center',
        className: 'custom-toast-success',
      });
    } else if (userLoginSuccess) {
      toast.success('User Login successful!', {
        autoClose: 1500,
        position: 'top-center',
        className: 'custom-toast-success',
      });
    } else {
      // Display an error message based on the error that occurred
      if (loginError) {
        toast.error(loginError, {
          autoClose: 1500,
          position: 'top-center',
          className: 'custom-toast-error',
        });
      } else if (userLoginError) {
        toast.error(userLoginError, {
          autoClose: 1500,
          position: 'top-center',
          className: 'custom-toast-error',
        });
      }
    }
  };


  

  useEffect(() => {
    // Update local storage after a delay
    const timeoutId = setTimeout(() => {
      if (localStorage.getItem('auth')) history.push('/timeinlive');
      localStorage.setItem('customerid', customerId);
      localStorage.setItem('companyid', companyId);
    }, 2000); // 2000 milliseconds (2 seconds) delay

    // Clear the timeout if the component unmounts or if customerId/companyId change
    return () => clearTimeout(timeoutId);
  }, [customerId, companyId]);

  return (
    <div className="auth-page">
      <Container className="col-12">
        <Row className="d-flex align-items-center">
        <Col xs={0} lg={6} className="right-column">
            <div>
              <img src={loginImage} alt="Error page" />
            </div>
          </Col>
          <Col xs={12} lg={6} className="left-column">
            <Widget className="widget-auth widget-p-lg">
              <div className="d-flex align-items-center justify-content-between py-3">
                <p className="auth-header mb-0">Login</p>
                <div className="logo-block">
                  <img src={Logotime} alt="My logo" width="200" height="70" />
                </div>
              </div>
              <form onSubmit={handleLogin}>
                <FormGroup className="my-3">
                  <FormText>Customer Name</FormText>
                  <Input
                    id="customername"
                    className="input-transparent pl-3"
                    onChange={(e) => setCustomername(e.target.value)}
                    type="customername"
                    required
                    name="customername"
                    placeholder="Enter customer name"
                  />
                </FormGroup>
                <FormGroup className="my-3">
                  <FormText>User Name</FormText>
                  <Input
                    id="username"
                    className="input-transparent pl-3"
                    onChange={(e) => setUsername(e.target.value)}
                    type="username"
                    required
                    name="username"
                    placeholder="Enter user name"
                  />
                </FormGroup>
                <FormGroup className="my-3">
                  <div className="d-flex justify-content-between">
                    <FormText>Password</FormText>
                  </div>
                  <Input
                    id="pass"
                    className="input-transparent pl-3"
                    onChange={(e) => setPass(e.target.value)}
                    type="password"
                    required
                    name="pass"
                    placeholder="Enter the password"
                  />
                </FormGroup>
                <div className="bg-widget d-flex justify-content-center">
                  <Button className="rounded-pill my-3" type="submit" color="secondary-red">Login</Button>
                </div>
              </form>
            </Widget>
          </Col>
         
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
}

export default Login;
